/** @jsxImportSource @emotion/react */

'use client';

import { Box, Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { Title } from '@campaign-manager/react/components';
import Button from '@campaign-manager/react/components/Button';
import Text from '@campaign-manager/react/components/Text';

import * as styles from '../ErrorPage/styles';

interface Cta {
  label: string;
  href?: string;
  onClick?: () => void;
}

export interface Props {
  heroTitle?: string;
  title?: string;
  body?: ReactNode | string;
  primaryCta?: Cta;
  secondaryCta?: Cta;
}

export default function ErrorBlock({ heroTitle, title, body, primaryCta, secondaryCta }: Props) {
  return (
    <Box css={styles.content}>
      <Stack
        sx={{
          gap: 0,
          alignItems: 'start',
        }}
      >
        {heroTitle && (
          <Text
            size="7xl"
            weight="bold"
            align="left"
          >
            {heroTitle}
          </Text>
        )}
        <Title size="lg">{title || 'We encountered a technical issue'}</Title>
        {body && (
          <Text
            whiteSpace="pre-line"
            component="div"
          >
            {body}
          </Text>
        )}
        <Stack
          direction="row"
          sx={{
            gap: 2,
            alignItems: 'end',
            mt: 5,
          }}
        >
          {secondaryCta && (
            <Button
              href={secondaryCta.href}
              onClick={secondaryCta.onClick}
            >
              {secondaryCta.label}
            </Button>
          )}
          {primaryCta && (
            <Button
              variant="contained"
              href={primaryCta.href}
              onClick={primaryCta.onClick}
            >
              {primaryCta.label}
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
